// extracted by mini-css-extract-plugin
export default {"asteriskMargin":"QXaXlh","label":"Ha7vLJ","hidden":"_mvMIZ"};